import { Box } from '@mui/material';
import IncTextField from 'components/forms/fields/inc-text-field/inc-text-field.component';
import { useTranslation } from 'react-i18next';
import IncSwitchField from '../fields/inc-switch-field/inc-switch-field.component';
import DisplayInformationFieldProvider from '../fields/display-information-field/display-information-field.context';
import DisplayLanguageTabs from '../fields/display-information-field/display-language-tabs/display-language-tabs.component';
import LocationDisplayInfoForm from '../location/information/location-display-info/display-info-form/display-info-form.component';

const CreateRelatedLocationForm = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <IncTextField
        name="relatedLocationName"
        label={t(
          'forms.fields.createRelatedLocationForm.relatedLocationName.label',
        )}
        data-testid="CreateRelatedLocationForm.RelatedLocationName"
      />

      <IncSwitchField
        name="isCatering"
        label={t('forms.fields.createRelatedLocationForm.isCatering.label')}
        data-testid="CreateRelatedLocationForm.IsCatering"
        helperText={t(
          'forms.fields.createRelatedLocationForm.isCatering.helperText',
        )}
      />

      <DisplayInformationFieldProvider name="displayInfo">
        <DisplayLanguageTabs
          displayFieldSet={index => (
            <Box p={0.5}>
              <LocationDisplayInfoForm
                fieldNames={{
                  title: `displayInfo.${index}.title`,
                  shortDescription: `displayInfo.${index}.shortDescription`,
                  longDescription: `displayInfo.${index}.longDescription`,
                  smallImage: `displayInfo.${index}.smallImage`,
                  mediumImage: `displayInfo.${index}.mediumImage`,
                }}
              />
            </Box>
          )}
        />
      </DisplayInformationFieldProvider>
    </Box>
  );
};

export default CreateRelatedLocationForm;
